module.exports = __webpack_public_path__ + "img/Logo-20.502cb1be.svg";